import api from './http';

export const ReportsAPI = {
  overview: () => api.get('/reports/overview').then((response) => response.data),
  auvoTasks: (params = {}) => api.get('/reports/auvo/tasks', { params }).then((response) => response.data),
  auvoOs: (params = {}) => api.get('/reports/auvo/os', { params }).then((response) => response.data),
  blingProposals: (params = {}) => api.get('/reports/bling/proposals', { params }).then((response) => response.data),
  clientUsage: (params = {}) => api.get('/reports/usage/clients', { params }).then((response) => response.data),
  productUsage: (params = {}) => api.get('/reports/usage/products', { params }).then((response) => response.data)
};
